import { ChevronDown } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const ChevronDownIcon = DeckardIconWrapper({ Icon: ChevronDown });
